"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericErrorResponseSchema = void 0;
var _axios = require("axios");
var _zod = require("zod");
const BaseErrorWithStatusCodeResponseSchema = _zod.z.object({
  statusCode: _zod.z.nativeEnum(_axios.HttpStatusCode),
  body: _zod.z.object({
    error: _zod.z.object({
      code: _zod.z.string(),
      message: _zod.z.string(),
      detail: _zod.z.string()
    })
  })
});
const BaseErrorResponseSchema = _zod.z.object({
  error: _zod.z.object({
    code: _zod.z.string(),
    message: _zod.z.string(),
    detail: _zod.z.string()
  })
});
const GenericErrorResponseSchema = exports.GenericErrorResponseSchema = _zod.z.union([BaseErrorWithStatusCodeResponseSchema.transform(function (_ref) {
  let {
    body: {
      error
    }
  } = _ref;
  return {
    error
  };
}), BaseErrorResponseSchema]);